import { AxiosInstance } from 'axios';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';

export type PreferenceValue = string | number | boolean | null | PreferenceValue[] | { [key: string]: PreferenceValue };
export type FbaTransportPreferences = Record<string, PreferenceValue>;

export interface FbaTransportPreferencesResponse {
    data: Record<string, FbaTransportPreferences>
}

export interface SetFbaTransportPreferenceRequest {
    owner_uuid: string
    key: string
    value: PreferenceValue
}

export interface SetFbaTransportPreferenceResponse {
    data: SetFbaTransportPreferenceRequest
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): {
    fetchPreferences: (owner: { warehouseUuid: string } | { merchantUuid: string }) => Promise<FbaTransportPreferences>
    setPreference: (request: SetFbaTransportPreferenceRequest) => Promise<SetFbaTransportPreferenceRequest>
} => ({
    fetchPreferences: async (owner): Promise<FbaTransportPreferences> => {
        const ownerUuid = 'warehouseUuid' in owner ? owner.warehouseUuid : owner.merchantUuid;
        const params = 'warehouseUuid' in owner ? { warehouse_uuid: owner.warehouseUuid } : { merchant_uuid: owner.merchantUuid };
        const response = await axios.get<FbaTransportPreferencesResponse>('/api/fba-transport/preferences', { params });
        return response.data.data[ownerUuid] ?? {};
    },
    setPreference: async (request): Promise<SetFbaTransportPreferenceRequest> => {
        const response = await axios.put<SetFbaTransportPreferenceResponse>('/api/fba-transport/preferences', request);
        return response.data.data;
    },
});
